import {
	IconDotsVertical,
	IconLogout,
	IconUserCircle,
} from "@tabler/icons-react"
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	useSidebar,
} from "@/components/ui/sidebar"
import { useMutation } from "@tanstack/react-query";
import { logoutController } from "@/features/auth/auth.controller";
import { toaster } from "./Toaster";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "@/app/routes/paths";
import { ModeToggleAlt } from "./mode-toggle-alt";

export function NavUser({
	user,
}: {
	user: {
		first_name: string;
		last_name: string;
		email: string
	}
}) {
	const { isMobile } = useSidebar()
	const navigate = useNavigate();

	const mutation = useMutation({
		mutationFn: logoutController,
		onError: (err: any) => {
			console.error("Login error:", err);
			const message = err?.response?.data?.error ?? err?.message ?? "Login failed";
			toaster("error", message);
		},
		onSuccess: () => {
			toaster("success", "Successfully logged out.");
			navigate(routes.LOGIN_PATH);
		},
	});

	const { mutate } = mutation;
	const isPending = mutation.status === "pending";

	const onSubmit = () => {
		mutate();
	};

	const popoutList = [
		{
			title: "Account",
			url: routes.ACCOUNT_PAGE_PATH,
			icon: IconUserCircle,
		},
		// {
		// 	title: "Notification",
		// 	url: "#",
		// 	icon: IconNotification,
		// },
		// {
		// 	title: "Billing",
		// 	url: "#",
		// 	icon: IconCreditCard,
		// },
	];

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<SidebarMenuButton
							size="lg"
							className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
						>
							<div className="h-8 w-8 rounded-lg bg-gray-200 dark:bg-gray-600 flex items-center justify-center grayscale">
								<span className="rounded-lg">
									{user.first_name.charAt(0).toUpperCase()}{user.last_name.charAt(0).toUpperCase()}
								</span>
							</div>
							<div className="grid flex-1 text-left text-sm leading-tight">
								<span className="truncate font-medium capitalize">{user.first_name + " " + user.last_name}</span>
								<span className="text-muted-foreground truncate text-xs">
									{user.email}
								</span>
							</div>
							<IconDotsVertical className="ml-auto size-4" />
						</SidebarMenuButton>
					</DropdownMenuTrigger>
					<DropdownMenuContent
						className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
						side={isMobile ? "bottom" : "right"}
						align="end"
						sideOffset={4}
					>
						<DropdownMenuLabel className="p-0 font-normal">
							<div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
								<div className="h-8 w-8 rounded-lg bg-gray-200 dark:bg-gray-600 flex items-center justify-center grayscale">
									<div className="rounded-lg">
										{user.first_name.charAt(0).toUpperCase()}{user.last_name.charAt(0).toUpperCase()}
									</div>
								</div>
								<div className="grid flex-1 text-left text-sm leading-tight">
									<span className="truncate font-medium capitalize">{user.first_name + " " + user.last_name}</span>
									<span className="text-muted-foreground truncate text-xs">
										{user.email}
									</span>
								</div>
							</div>
						</DropdownMenuLabel>
						<DropdownMenuSeparator />
						<DropdownMenuGroup>
							{
								popoutList.map(item => (
									<Link key={item.url} to={item.url} className="text-gray-600 dark:text-gray-300">
										<DropdownMenuItem className="cursor-pointer">
											<item.icon />
											{item.title}
										</DropdownMenuItem>
									</Link>
								))
							}
							<ModeToggleAlt />
						</DropdownMenuGroup>
						<DropdownMenuSeparator />
						<DropdownMenuItem onClick={onSubmit} disabled={isPending}>
							<IconLogout />
							Log out
						</DropdownMenuItem>
					</DropdownMenuContent>
				</DropdownMenu>
			</SidebarMenuItem>
		</SidebarMenu>
	)
}
